import { render, staticRenderFns } from "./AttendContent.vue?vue&type=template&id=0cb8027b&scoped=true&"
import script from "./AttendContent.vue?vue&type=script&lang=js&"
export * from "./AttendContent.vue?vue&type=script&lang=js&"
import style0 from "./AttendContent.vue?vue&type=style&index=0&id=0cb8027b&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb8027b",
  null
  
)

export default component.exports